import axiosBackEnd from "../../config/axios/axios-back-end";
import { apiStart, apiFail, apiComplete } from "./api";
import { message } from "antd";

export const reportcategoryHmgReportCategories = (hmg_id) => {
  return async (dispatch) => {
    try {
      dispatch(apiStart());
      const result = await axiosBackEnd.get(
        `/api/report-categories/hmg/${hmg_id}`,
        null,
        { headers: { "Content-Type": "application/json" } }
      );
      dispatch(apiComplete());
      return {
        reportcategories: result.data.hmg.reportcategory,
        hotels: result.data.hotels,
      };
    } catch (error) {
      dispatch(apiComplete());
      console.log(error);
      message.error(error.response.data);
      return {
        reportcategories: [],
        hotels: [],
      };
    }
  };
};
